import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import { Switch } from 'react-router'
import logo from './logo.svg'
import './App.css'

import { withStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'

import { configure } from 'mobx'
import { Provider, observer, inject } from 'mobx-react'

import Layout from './components/layout'
import About from './components/about'
import VideoStore from './stores/videoStore'

// MobX config:
configure({
  enforceActions: "always"
});

// Stores, add all stores imported above!
const stores = { 
  videoStore: VideoStore,
};


const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#6d6d6d',
      main: '#424242',
      dark: '#1b1b1b',
    },
    secondary: {
      light: '#ffc947',
      main: '#ff9800',
      dark: '#c66900',
      // contrastText: '#',
    }
  },
  button: { 
    height: 40,
  },
});

const styles = theme => ({
  root: {
    flexGrow: 1,
    margin: 0,
    position: 'relative',
  },
  button: {
    margin: theme.spacing(),
    padding: theme.spacing(),
  },
  control: {
    padding: theme.spacing(2),
  },
  flex: {
    flex: 1
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
});


@observer
class App extends Component {
  render() {
    const { classes } = this.props;
  
    // let num_videos = this.state.videos.length;

    return (
      <div className="App">
        <Provider {...stores}>
          <MuiThemeProvider theme={theme}>
            <Switch>
              <Route path="/" component={Layout}/>
              <Route path="/about" component={About}/>
            </Switch>
          </MuiThemeProvider>
        </Provider>
      </div>
    );
  }

  _onReady(event) {
    // access to player in all event handlers via event.target
    //event.target.pauseVideo();
    console.log('ready');
  }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/App.js